import React from 'react';
import PropTypes from 'prop-types';
import 'array-flat-polyfill';

import { ThemeProvider } from 'styled-components';
import { GridThemeProvider } from 'styled-bootstrap-grid';
import { TerraTheme } from './Themes';

export const Provider = ({ theme, children }) => (
    <ThemeProvider theme={theme}>
        <GridThemeProvider gridTheme={theme.global.gridTheme}>{children}</GridThemeProvider>
    </ThemeProvider>
);

Provider.propTypes = {
    theme: PropTypes.shape({ global: PropTypes.shape({ gridTheme: PropTypes.shape({}) }) }),
    children: PropTypes.node.isRequired,
};

Provider.defaultProps = {
    theme: TerraTheme,
};

export * from './Assets';
export * from './Themes';
export * from './Atoms';
export * from './Molecules';
export * from './Organisms';
export * from './Utils';
